import { useState } from 'react';
import {
    Datagrid,
    TextField,
    List,
    Pagination,
    TextInput,
    CreateButton,
    TopToolbar,
    EditButton,
    DeleteButton,
    FunctionField,
    Filter,
} from 'react-admin';
import { CopyIdButton } from '../../common/CopyIdButton';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const ListActions = ({ isAdmin }: any) => <TopToolbar>{isAdmin && <CreateButton />}</TopToolbar>;
const MetaDataList = () => {
    const [activeTab, setActiveTab] = useState(0);
    const user = JSON.parse(localStorage.getItem('user') as string);
    const isAdmin = user?.role === 'ADMIN';

    const tabData = [
        { label: 'Master Class', resource: 'master-classes' },
        { label: 'Master Subjects', resource: 'master-subjects' },
        { label: 'Master Chapters', resource: 'master-chapters' },
        { label: 'Master Topics', resource: 'master-topics' },
    ];
    return (
        <div className="border rounded-md mb-14">
            <div className="flex text-lg flex-row gap-16 px-10 pt-4 border-b">
                {tabData.map((tab, index) => (
                    <div
                        key={index}
                        onClick={() => setActiveTab(index)}
                        className={`cursor-pointer pb-2 ${
                            index === activeTab ? 'text-[#4f3cc9] border-b-4 border-[#4f3cc9]' : ''
                        }`}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
            <div className="p-4">
                <List
                    resource={tabData[activeTab].resource}
                    filters={<ListFilter />}
                    sort={{ field: 'displayOrder', order: 'ASC' }}
                    perPage={10}
                    pagination={<Pagination />}
                    actions={<ListActions isAdmin={isAdmin} />}
                    queryOptions={{
                        refetchOnWindowFocus: false,
                        refetchOnReconnect: false,
                    }}
                >
                    <Datagrid>
                        <CopyIdButton />
                        <TextField source="name" />
                        <FunctionField
                            label="Display Order"
                            render={(record: any) => record.displayOrder ?? '-'}
                        />
                        <FormattedDateTimeField source="created_at" />

                        {isAdmin && (
                            <>
                                <EditButton />
                                <ConfirmDeleteButton />
                            </>
                        )}

                        <FormattedDateTimeField source="created_at" />
                        {isAdmin && (
                            <>
                                <EditButton />
                                <ConfirmDeleteButton />
                            </>
                        )}
                    </Datagrid>
                </List>
            </div>
        </div>
    );
};

export default MetaDataList;
